import { render } from "./Events.vue?vue&type=template&id=f2fcc71a&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=f2fcc71a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2fcc71a"

export default script